module.exports = "<div class=\"mapheader\"></div>\r\n<div id=\"map\" class=\"contenedor\" ></div>"